export default __webpack_public_path__ + "static/tive-e49b47bc8b5dfe5d0430a78b7d930c96.png";